import xss from "xss";

const mapKundenAdressen = (a) => {
  if (!a) return;
  return {
    id: Number(a.id) || Number(a.adressId) || null,
    name: xss(a.name),
    strasse: xss(a.strasse),
    strasse2: xss(a.strasse2),
    plz: xss(a.plz),
    ort: xss(a.ort)
  };
};

export default {
  kundeAdressen: [],
  selectedAdresse: null,

  setAdressList(data) {
    if (!Array.isArray(data)) return;
    this.kundeAdressen = data.map(mapKundenAdressen);
  }
};
